import { defineMessages } from 'react-intl';

export const assumptionDeletionConfirmationModalMessageDefinitions = defineMessages({
  title: {
    id: 'assumptionDeletionConfirmationModal.title',
    defaultMessage: 'Deleting Assumption',
  },
  warningMessage: {
    id: 'assumptionDeletionConfirmationModal.warningMessage',
    defaultMessage: 'This will delete the assumption. The operation cannot be reverted.',
  },
  confirmButton: {
    id: 'assumptionDeletionConfirmationModal.confirmButton',
    defaultMessage: 'Confirm Removing',
  },
});
